var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9884 10.8876L13.1109 13.8726M13.1034 5.63758L7.9884 8.62258M17.2959 4.50508C17.2959 5.74772 16.2885 6.75508 15.0459 6.75508C13.8033 6.75508 12.7959 5.74772 12.7959 4.50508C12.7959 3.26244 13.8033 2.25508 15.0459 2.25508C16.2885 2.25508 17.2959 3.26244 17.2959 4.50508ZM8.2959 9.75508C8.2959 10.9977 7.28854 12.0051 6.0459 12.0051C4.80326 12.0051 3.7959 10.9977 3.7959 9.75508C3.7959 8.51244 4.80326 7.50508 6.0459 7.50508C7.28854 7.50508 8.2959 8.51244 8.2959 9.75508ZM17.2959 15.0051C17.2959 16.2477 16.2885 17.2551 15.0459 17.2551C13.8033 17.2551 12.7959 16.2477 12.7959 15.0051C12.7959 13.7624 13.8033 12.7551 15.0459 12.7551C16.2885 12.7551 17.2959 13.7624 17.2959 15.0051Z",
    stroke: "#131518",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.54c42f7e6f1d2b070e8d5bf8122e65c4.svg";
export { ForwardRef as ReactComponent };